import StyledButton from "../Components/UI/StyledButton";
import CourseListBlock from "../Components/Modules/CourseList/CourseListBlock";
import AuthorSwiper from "../Components/Modules/CourseList/AuthorSwiper";
import headCourseBackground from "../Assets/Images/главная-страница-фон.jpg";
import headCourseLayout from "../Assets/Images/главная-страница-слой.png";
import { useEffect, useState } from "react";
import CourseBlockInterface from "../Interfaces/CourseBlockInterface";
import TestForm from "../Components/Modules/Test/TestForm";
import { readItems } from "@directus/sdk";
import { directus } from "../Api/FetchDirectus";
import { useNavigate } from "react-router-dom";
import LoggedTestForm from "../Components/Modules/Test/LoggedTestForm";

const CoursesListPage = () => {
  const navigate = useNavigate();
  const [courseList, setCourseList] = useState<
    Array<CourseBlockInterface> | Record<string, any>[]
  >([]);
  const [emirDescription, setEmirDescription] = useState<Record<string, any>>();
  const [openForm, setOpenForm] = useState(false);

  const fetchCourse = async () => {
    try {
      return await directus.request(readItems(`Course`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchDescription = async () => {
    try {
      return await directus.request(readItems(`emir_courses_description`));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return;
    }
  };

  async function fetchCourseList() {
    setCourseList([...(await fetchCourse())]);
  }

  async function fetchEmirDescription() {
    fetchDescription().then((response) => {
      setEmirDescription(response);
    });
  }

  useEffect(() => {
    fetchCourseList();
    fetchEmirDescription();
  }, []);

  return (
    <div className="coursesListPage">
      <div className="headCourseBlock">
        <div className="headCourseBlockText">
          <h1>Тест на определение профессиональных компетенций</h1>
          <div className="headCourseBlockDescription">
            Пройдите тестирование, чтобы определить свой уровень
            профессиональных компетенций и подобрать онлайн-курс
          </div>
          <StyledButton
            className="blueButton"
            text="НАЧАТЬ ТЕСТИРОВАНИЕ"
            onClick={() => setOpenForm(true)}
          ></StyledButton>
        </div>
        <div className="headImageBlock">
          <img alt="" src={headCourseLayout} className="headCourseLayout" />
          <img
            alt=""
            src={headCourseBackground}
            className="headCourseBackground"
          />
        </div>
      </div>
      <div className="coursesList">
        <h2>Все курсы</h2>
        <div className="coursesListContent">
          {courseList.map((item, index) => {
            return (
              <CourseListBlock
                key={index}
                id={item.id}
                title={item.title}
                description={item.description}
                course_details={item.course_details}
                duration={item.duration}
                hours={item.hours}
                document_name={item.document_name}
                course_video={item.course_video}
                access_type={item.access_type}
                modules={item.modules}
                track_list={item.track_list}
                layout={item.layout}
                background_color={item.background_color}
                background_non_color={item.background_non_color}
                price={item.price}
                suitable={item.suitable}
                test_certificat_id={item.test_certificat_id}
                certificat_hours={item.certificat_hours}
              />
            );
          })}
        </div>
      </div>
      <div className="attractBox">
        <div
          className="coldLetter"
          dangerouslySetInnerHTML={{
            __html: emirDescription?.description_text,
          }}
        ></div>
        <div className="authorsList">
          <h2>Авторы курсов</h2>
          <AuthorSwiper />
        </div>
      </div>
      {openForm && !sessionStorage.getItem("token") && (
        <TestForm close={(e: boolean) => setOpenForm(e)} />
      )}{" "}
      {openForm && sessionStorage.getItem("token") && (
        <LoggedTestForm close={(e: boolean) => setOpenForm(e)} />
      )}
    </div>
  );
};

export default CoursesListPage;
